import React from 'react';
import './FloatingBadge.css';

const FloatingBadge = () => {
  return (
    <a
      href="https://rockyourpresence.ch/"
      target="_blank"
      rel="noopener noreferrer"
      className="floating-badge"
      aria-label="Created by Rock Your Presence"
    >
      <div className="badge-content">
        <span className="badge-text">created by</span>
        <img
          src="https://customer-assets.emergentagent.com/job_aef2aa9d-1a3c-46d3-9c1b-ca1e22440c7e/artifacts/x77ykhai_RockYourPresecence-Marketingagentur-Lenzburg-logo-horizontal-schwarz-weiss.png"
          alt="Rock Your Presence"
          className="badge-logo"
        />
      </div>
    </a>
  );
};

export default FloatingBadge;
